export const webAccountText = {
  appUpdate: {
    ready: '发现新版本',
    update: '更新',
    updating: '正在检查…',
    offline: '网络恢复后可更新',
    draftFailed: '草稿未保存，请稍后重试',
    dismiss: '关闭更新提示',
    availableVersion: '可更新至',
    label: '应用更新',
    about: '关于 StoryTune',
    currentVersion: '当前版本',
    build: '构建标识',
  },
  conversationTools: '会话工具',
  conversationHistory: '历史',
  storyRound: '本轮内容',
  conversationSoundOn: '开启声音',
  conversationSoundOff: '关闭声音',
  characterAudioFailed: '声音暂时无法播放，继续显示文字',
  openingAudioEnable: '点击开启声音',
  storyAudioTimedOut: '语音准备超时，已继续显示文字',
  storyAudioFailed: '这段声音暂时无法播放，继续显示文字',
  storyReadingProgressFailed: '章节进度暂时无法读取',
  storyScene: '当前故事场景',
  cardInfo: '查看卡片介绍',
  storyNarration: '场景叙述',
  deleteMessageConfirm: '确认删除这条消息？此操作无法撤销。',
  messageActions: '消息操作',
  close: '关闭',
  copied: '已复制',
  latestMessage: '回到最新消息',
  storyProgress: '故事进度',
  storyCompleted: '故事已结束',
  storyFailed: '故事未达成',
  currentChapter: '当前章节',
  chapterCompleted: '已完成',
  chapterFailed: '未达成',
  upcomingChapter: '尚未开始',
  emptyMemory: '暂无可展示的记忆。',
  callStarted: '通话开始',
  callEnded: '通话结束',
  accountMenu: '账号菜单',
  login: '手机号登录',
  loginAction: '登录',
  loginWelcome: '走进时光，慢慢聊',
  loginTitleFirst: '走进时光，',
  loginTitleAccent: '慢慢聊。',
  loginEncounter: '在这里，遇见老朋友',
  loginContinue: '登录，接着聊',
  loginFree: '免费登录',
  chatLoginHint: '登录后即可聊天，聊天记录自动保存。',
  chatLoginHintCompact: '登录后即可聊天',
  chatLoginHintLabel: '登录提示',
  loginBenefit: '把聊过的日常、走过的故事，留到下一次。',
  loginContext: '登录后，继续和{name}聊。',
  loginWechat: '微信扫码，开始聊天',
  loginSaved: '聊天自动保存',
  loginAcrossDevices: '手机电脑接着聊',
  loginReturn: '先看看',
  loginMobileHelp: '用另一台手机的微信扫一扫，进入小程序确认登录。',
  loginMobileNote: '当前支持微信扫码登录，需要另一台设备协助扫码。',
  loginPreparing: '正在准备登录码…',
  loginRetry: '重新获取登录码',
  loginAccountHelp: '使用微信账号登录，无需另外注册。',
  loginResumeFailed: '登录已完成，暂时无法打开聊天。请重试，刚才输入的内容仍保留。',
  publicChatDescription: '选一个人物或故事，看看开场，想好你的第一句话。',
  publicRecommendedOpenings: '推荐开场',
  publicOpeningUnavailable: '这个推荐开场暂时不可用，请返回选择其他内容。',
  publicMyDescription: '登录后，查看你的作品，创作自己的人物和故事。',
  publicProtectedTitle: '登录，回到你的空间',
  publicProtectedDescription: '聊天记录和个人内容仅在登录后可见。',
  publicExplore: '去探索',
  discoverySearch: '搜索感兴趣的内容',
  discoveryFilters: '内容分类',
  discoveryClearSearch: '清除搜索',
  loginHelp: '用微信扫码打开 StoryTune 小程序，并在手机上确认登录。',
  refreshCode: '刷新登录码',
  waiting: '等待手机确认…',
  expired: '登录码已过期，请刷新。',
  canceled: '已取消登录，可刷新登录码重试。',
  loading: '正在加载…',
  retry: '重试',
  logout: '退出登录',
  switchUser: '切换用户',
  ownSpace: '返回我的空间',
  acting: '正在使用其他用户的空间',
  home: '首页',
  feedEmpty: '暂时没有可浏览的人物或故事',
  feedLoadFailed: '首页暂时没有连上，请重试',
  feedCardFailed: '这张卡片暂时无法打开',
  feedLoadTimeout: '加载时间较长，可以重试或继续滑动',
  feedBrowse: '浏览人物和故事',
  my: '我的',
  primaryNavigation: '主导航',
  explore: '探索',
  chats: '聊天',
  newChat: '新聊天',
  newChatDescription: '选一个人物或故事，开始新的聊天。',
  creations: '我的作品',
  emptyChats: '还没有会话，去探索认识一个人物或体验故事吧。',
  emptyConversationPreview: '刚刚认识，还没有说话',
  deleteConversationLabel: (name: string) => `删除与${name}的聊天`,
  deleteConversation: '删除',
  deletingConversation: '删除中…',
  deleteConversationFailed: '暂时无法完成删除，请刷新列表后重试。',
  deleteConversationBusy: '这段聊天还在处理回复或记忆，请稍后再删除。',
  chooseConversation: '从左侧选择会话，继续聊天。',
  send: '发送',
  placeholder: '说点什么…',
  characterChatPlaceholder: '自由输入...',
  storyChatPlaceholder: '你想怎么做？',
  confirmTitle: '确认登录电脑网页',
  confirm: '确认登录',
  cancel: '取消',
  site: '登录网站',
  account: '当前账号',
  confirmed: '已确认，请回到电脑网页。',
  invalid: '登录请求无效或已经过期，请在电脑上刷新登录码。',
  voice: '朗读',
  memory: '记忆',
  back: '返回',
  start: '开始聊天',
  story: '故事',
  character: '人物',
  readFailed: '读取失败，请重试',
  networkError: '网络连接失败，请检查网络后重试',
  routeLoadFailed: '页面暂时无法加载，请重试',
  confirmHelp: '请确认这是您正在使用的电脑。确认后，网页将访问此账号的聊天与故事。',
  returnHome: '返回 StoryTune',
  codeFailed: '登录码暂时无法加载，请稍后刷新重试。',
} as const
